import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import "../../../assets/css/gamesCss/Graph/searchingDirected.css"
import GameOverModal from "../../../components/GameOverModal";
import GameWonModal from "../../../components/GameWonModal";
import { faL } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from "reactstrap"
import { useFinishedGame } from "../../../components/gameXpFunction"  //here
import { useDarkMode } from "../../../context/DarkModeProvider";
import { useLanguage } from 'context/LanguageProvider';
//import { s } from 'framer-motion/dist/types.d-Cjd591yU';


const SearchingDirected = () => {

    const selectedStage = JSON.parse(localStorage.getItem("selectedStage"));
    var games = selectedStage.games;
    var nameGameKey = localStorage.getItem("gameClicked");
    var selectedGame = null;
    for (let i = 0; i < games.length; i++) {
        if (games[i].game_title === nameGameKey) {
            selectedGame = games[i];
            break;
        }
    }


    const { selLanguage, toggleLanguage, isLoading } = useLanguage();

    // Σωστές απαντήσεις
    const correctAnswers = {
        DFS: "A D E H J I F G",
        BFS: "A D B E F C H I G J"
    };

    //here
    const { handleGameComplete, isProcessing } = useFinishedGame();
    const gameCompletedRef = useRef(false);

    const nodes = [
        { id: 'A', x: 100, y: 50, label: 'Start A' },
        { id: 'B', x: 300, y: 50, label: 'Node B' },
        { id: 'C', x: 500, y: 50, label: 'Node C' },
        { id: 'D', x: 50, y: 150, label: 'Node D' },
        { id: 'E', x: 200, y: 150, label: 'Central E' },
        { id: 'F', x: 350, y: 150, label: 'Node F' },
        { id: 'G', x: 500, y: 150, label: 'Node G' },
        { id: 'H', x: 150, y: 250, label: 'Node H' },
        { id: 'I', x: 350, y: 250, label: 'Node I' },
        { id: 'J', x: 250, y: 350, label: 'Target J' }
    ];

    // Πιο περίπλοκες διασυνδέσεις
    const edges = [
        { from: 'A', to: 'B', weight: 4, color: '#8b5cf6' },
        { from: 'A', to: 'D', weight: 2, color: '#8b5cf6' },
        { from: 'B', to: 'C', weight: 3, color: '#8b5cf6' },
        { from: 'B', to: 'E', weight: 5, color: '#8b5cf6' },
        { from: 'B', to: 'F', weight: 1, color: '#8b5cf6' },
        { from: 'C', to: 'G', weight: 6, color: '#8b5cf6' },
        { from: 'D', to: 'E', weight: 3, color: '#8b5cf6' },
        { from: 'E', to: 'F', weight: 2, color: '#8b5cf6' },
        { from: 'E', to: 'H', weight: 4, color: '#8b5cf6' },
        { from: 'F', to: 'G', weight: 5, color: '#8b5cf6' },
        { from: 'F', to: 'I', weight: 3, color: '#8b5cf6' },
        { from: 'G', to: 'I', weight: 2, color: '#8b5cf6' },
        { from: 'H', to: 'I', weight: 1, color: '#8b5cf6' },
        { from: 'H', to: 'J', weight: 4, color: '#8b5cf6' },
        { from: 'I', to: 'J', weight: 2, color: '#8b5cf6' },
        { from: 'E', to: 'B', weight: 3, color: '#8b5cf6' },
        { from: 'I', to: 'F', weight: 1, color: '#8b5cf6' }
    ];

    const [selectedNode, setSelectedNode] = useState(null);
    const [hoveredEdge, setHoveredEdge] = useState(null);
    const [animationStep, setAnimationStep] = useState(0);
    const [flowAnimation, setFlowAnimation] = useState(false);
    const [showOptionsBFS, setShowOptionsBFS] = useState(false);
    const [showOptionsDFS, setShowOptionsDFS] = useState(false);
    const [showGameOver, setShowGameOver] = useState(false);
    const [showGameWon, setShowGameWon] = useState(false);
    const [lives, setLivesLeft] = useState(3);
    const { darkMode } = useDarkMode();

    // Νέα state για τα αποτελέσματα
    const [dfsResult, setDfsResult] = useState(null); // null, 'correct', 'incorrect'
    const [bfsResult, setBfsResult] = useState(null);
    const [selectedDfsOption, setSelectedDfsOption] = useState(null);
    const [selectedBfsOption, setSelectedBfsOption] = useState(null);

    const handleSelectAnswer = (option, type) => {
        const isCorrect = correctAnswers[type] === option;

        if (type === 'DFS') {
            setSelectedDfsOption(option);
            setDfsResult(isCorrect ? 'correct' : 'incorrect');
        } else {
            setSelectedBfsOption(option);
            setBfsResult(isCorrect ? 'correct' : 'incorrect');
        }

        if (!isCorrect) {
            setLivesLeft(prev => prev - 1);
        }
    };

    const resetGame = () => {
        gameCompletedRef.current = false;
        setLivesLeft(3);
        setDfsResult(null);
        setBfsResult(null);
        setSelectedDfsOption(null);
        setSelectedBfsOption(null);
        setShowOptionsDFS(false);
        setShowOptionsBFS(false);
        setShowGameOver(false);
        setShowGameWon(false);
        setSelectedNode(null);
        setHoveredEdge(null);
        setAnimationStep(0);
        setFlowAnimation(false);
        localStorage.setItem("gameFirstTry", false);

        // ✅ ΕΔΩ: Επαναφέρουμε το flag για να μπορεί να ξαναπαίξει
        // (Αλλά δεν θα πάρει XP γιατί το gameFirstTry είναι πλέον "false")

        setTimeout(() => {
            setAnimationStep(1);
            setTimeout(() => setFlowAnimation(true), 3000);
        }, 100);
    };
    useEffect(() => {
        if (lives === 0) {
            setTimeout(() => setShowGameOver(true), 1000);
        }

        // heree
        if (dfsResult === 'correct' && bfsResult === 'correct' && !gameCompletedRef.current) {
            gameCompletedRef.current = true;
            handleGameComplete();
            setTimeout(() => setShowGameWon(true), 1000);
        }
    }, [lives, dfsResult, bfsResult]);

    // Reset επιλογής όταν κάνει λάθος
    const resetSelection = (type) => {
        if (type === 'DFS') {
            setDfsResult(null);
            setSelectedDfsOption(null);
        } else {
            setBfsResult(null);
            setSelectedBfsOption(null);
        }
    };

    // Υπολογισμός θέσης και γωνίας για τις ακμές
    const calculateEdge = (from, to) => {
        const fromNode = nodes.find(n => n.id === from);
        const toNode = nodes.find(n => n.id === to);

        const dx = toNode.x - fromNode.x;
        const dy = toNode.y - fromNode.y;
        const length = Math.sqrt(dx * dx + dy * dy);
        const angle = Math.atan2(dy, dx) * (180 / Math.PI);

        // Προσαρμογή για καλύτερη θέση βέλους
        const offset = 30;
        const startX = fromNode.x + offset + (offset * Math.cos(angle * Math.PI / 180));
        const startY = fromNode.y + offset + (offset * Math.sin(angle * Math.PI / 180));

        return {
            x: startX,
            y: startY,
            width: length - (2 * offset),
            angle,
            midX: fromNode.x + dx / 2,
            midY: fromNode.y + dy / 2,
            endX: toNode.x + offset - (offset * Math.cos(angle * Math.PI / 180)),
            endY: toNode.y + offset - (offset * Math.sin(angle * Math.PI / 180))
        };
    };

    // Βελτιωμένο βέλος με καλύτερη ροή
    const Arrow = ({ edge, isHovered, index }) => {
        const edgeData = calculateEdge(edge.from, edge.to);
        const strokeColor = isHovered ? '#ffffff' : edge.color;
        const strokeWidth = isHovered ? 4 : 3;

        return (
            <g>
                {/* Σκιά βέλους για βάθος */}
                <motion.line
                    x1={2}
                    y1={2}
                    x2={edgeData.width + 2}
                    y2={2}
                    stroke="rgba(0,0,0,0.2)"
                    strokeWidth={strokeWidth + 1}
                    transform={`translate(${edgeData.x}, ${edgeData.y}) rotate(${edgeData.angle})`}
                    initial={{ pathLength: 0 }}
                    animate={{ pathLength: 1 }}
                    transition={{ duration: 1.2, delay: index * 0.15 }}
                />

                {/* Κύρια γραμμή βέλους */}
                <motion.line
                    x1={0}
                    y1={0}
                    x2={edgeData.width}
                    y2={0}
                    stroke={strokeColor}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    transform={`translate(${edgeData.x}, ${edgeData.y}) rotate(${edgeData.angle})`}
                    onMouseEnter={() => setHoveredEdge(edge)}
                    onMouseLeave={() => setHoveredEdge(null)}
                    style={{ cursor: 'pointer' }}
                />

                {/* Animated flow dots για ροή */}
                <AnimatePresence>
                    {(flowAnimation || isHovered) && (
                        <>
                            {[0, 1, 2].map((dotIndex) => (
                                <motion.circle
                                    key={`flow-${edge.from}-${edge.to}-${dotIndex}`}
                                    r="3"
                                    fill={strokeColor}
                                    transform={`translate(${edgeData.x}, ${edgeData.y}) rotate(${edgeData.angle})`}
                                    initial={{ cx: 0, opacity: 0 }}
                                    animate={{
                                        cx: edgeData.width,
                                        opacity: [0, 1, 1, 0]
                                    }}
                                    transition={{
                                        duration: 2,
                                        delay: dotIndex * 0.3,
                                        repeat: Infinity,
                                        repeatDelay: 1
                                    }}
                                    exit={{ opacity: 0 }}
                                />
                            ))}
                        </>
                    )}
                </AnimatePresence>

                {/* Μεγαλύτερη κεφαλή βέλους */}
                <motion.polygon
                    points={`${edgeData.endX},${edgeData.endY} ${edgeData.endX - 20 * Math.cos((edgeData.angle - 30) * Math.PI / 180)},${edgeData.endY - 20 * Math.sin((edgeData.angle - 30) * Math.PI / 180)} ${edgeData.endX - 20 * Math.cos((edgeData.angle + 30) * Math.PI / 180)},${edgeData.endY - 20 * Math.sin((edgeData.angle + 30) * Math.PI / 180)}`}
                    fill={strokeColor}
                    stroke="#1f2937"
                    strokeWidth="2"
                    whileHover={{ scale: 1.4 }}
                />
            </g>
        );
    };

    const toggleFlowAnimation = () => {
        setFlowAnimation(!flowAnimation);
    };

    useEffect(() => {
        setAnimationStep(1);
        setTimeout(() => setFlowAnimation(true), 3000);
    }, []);

    // Render των επιλογών με αποτελέσματα
    const renderOptions = (type, showOptions, setShowOptions, result, selectedOption) => {

        const dfsOptions = ["A B E F G I F", "A D E H J I F G", "C G I J F", " A D E B C G F"]; //2h epilogh
        const bfsOptions = ["A D B E H F C G", "D E B F H C G I F", "A B D C F E H J", "A D B E F C H I G J"];

        var options = [];
        if (type === 'DFS') options = dfsOptions;
        else options = bfsOptions;


        return (
            <div style={{ display: "flex", flexDirection: "column", alignItems: type === 'DFS' ? "flex-start" : "flex-end" }}>
                <button
                    onClick={() => result === 'correct' ? null : setShowOptions(!showOptions)}
                    className='searchingDirectedChoosePath'
                    style={{
                        backgroundColor: result === 'correct' ? '#10b981' : undefined,
                        cursor: result === 'correct' ? 'default' : 'pointer',
                        opacity: result === 'correct' ? 0.8 : 1
                    }}
                    onMouseEnter={(e) => {
                        if (result !== 'correct') {
                            e.currentTarget.style.transform = "scale(1.05)";
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (result !== 'correct') {
                            e.currentTarget.style.transform = "scale(1)";
                        }
                    }}
                >
                    {selLanguage
                        ? (result === 'correct'
                            ? `✓ Σωστό: ${correctAnswers[type]}`
                            : `Διάλεξε μονοπάτι για ${type}`)
                        : (result === 'correct'
                            ? `✓ Correct: ${correctAnswers[type]}`
                            : `Choose path for ${type}`)
                    }
                </button>

                {showOptions && result !== 'correct' && (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "12px",
                            alignItems: type === 'DFS' ? "center" : "flex-end",
                            transform: type === 'DFS' ? "translateX(20px)" : "translateX(0px)",
                            marginTop: "12px"
                        }}
                    >
                        {options.map((option, idx) => (

                            <div key={option} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <button
                                    onClick={() => handleSelectAnswer(option, type)}
                                    className='searchingDirectedSelectionButtons'
                                    style={{
                                        backgroundColor: selectedOption === option
                                            ? (result === 'incorrect' ? '#d01e1eff' : undefined)
                                            : undefined
                                    }}
                                >
                                    {option}
                                </button>

                            </div>

                        ))}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div
            className='main-content searchingDirectedContainer'
            style={{
                background: darkMode ? "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #101724ff 100%)" : "var(--lightModeGameBackground)"
            }}
        >
            <GameOverModal
                isVisible={showGameOver}
                onPlayAgain={resetGame}

            />

            <GameWonModal
                isVisible={showGameWon}
                onPlayAgain={resetGame}

            />
            <div className="max-w-7xl mx-auto" style={{ width: "100%" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "flex-end", marginBottom: "5px", marginTop: "7px" }}>
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "row",
                        justifyContent: "right",
                        gap: "12px"
                    }}>


                        <div style={{
                            display: "flex",
                            gap: "6px",
                            alignItems: "center"
                        }}>
                            {[1, 2, 3].map((heartNum) => (
                                <div
                                    key={heartNum}
                                    style={{
                                        fontSize: "24px",
                                        filter: lives >= heartNum
                                            ? "drop-shadow(0 4px 8px rgba(220, 38, 38, 0.4))"
                                            : "grayscale(100%) opacity(0.3)",
                                        transform: lives >= heartNum ? "scale(1)" : "scale(0.8)",
                                        transition: "all 0.3s ease",
                                        animation: lives >= heartNum ? "heartbeat 2s ease-in-out infinite" : "none"
                                    }}
                                >
                                    ❤️
                                </div>
                            ))}
                        </div>


                    </div>

                    <style>{`
                        @keyframes heartbeat {
                            0%, 100% { transform: scale(1); }
                            50% { transform: scale(1.1); }
                        }
                    `}</style>
                </div>

                <br></br>

                <div className='searchingDirectedPron'>
                    {selLanguage ? `Βρες τη σωστή σειρά επίσκεψης των κόμβων χρησιμοποιώντας DFS και BFS αντίστοιχα.` : `Find the correct order of visiting nodes using DFS and BFS.`}
                </div>
                <div className='searchingDirectedFrame'>
                    <svg
                        width="100%"
                        height="auto"
                        viewBox="0 0 700 450"
                        style={{ maxWidth: "700px", width: "100%", height: "auto", display: "block" }}
                    >
                        {/* Background grid */}
                        <defs>
                            <pattern width="40" height="40" patternUnits="userSpaceOnUse">
                                <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#e2e8f0" strokeWidth="1" opacity="0.3" />
                            </pattern>
                        </defs>
                        <rect width="100%" height="100%" fill="url(#grid)" />

                        {/* Ακμές */}
                        {edges.map((edge, index) => (
                            <Arrow
                                key={`${edge.from}-${edge.to}`}
                                edge={edge}
                                index={index}
                            />
                        ))}

                        {/* Κόμβοι */}
                        {nodes.map((node, index) => (
                            <motion.g key={node.id}>
                                {/* Σκιά κόμβου */}
                                <motion.circle
                                    cx={node.x + 32}
                                    cy={node.y + 32}
                                    r="28"
                                    fill="rgba(0,0,0,0.2)"
                                    initial={{ scale: 0 }}
                                    animate={{ scale: 1 }}
                                    transition={{ duration: 0.6, delay: index * 0.1 }}
                                />

                                {/* Κύριος κόμβος */}
                                <motion.circle
                                    cx={node.x + 30}
                                    cy={node.y + 30}
                                    r="28"
                                    fill={selectedNode === node.id ? "#3b82f6" : `url(#gradient-${node.id})`}
                                    stroke="#1f2937"
                                    strokeWidth="3"
                                    className="cursor-pointer"
                                    initial={{ scale: 0, rotate: 0 }}
                                    animate={{ scale: 1, rotate: 360 }}
                                    whileHover={{
                                        scale: 1.15,
                                        boxShadow: "0 0 25px rgba(59, 130, 246, 0.6)"
                                    }}
                                />

                                {/* Gradient definitions για κάθε κόμβο */}
                                <defs>
                                    <radialGradient id={`gradient-${node.id}`}>
                                        <stop offset="0%" stopColor="#3b82f6" />
                                        <stop offset="100%" stopColor="#3b82f6" />
                                    </radialGradient>
                                </defs>

                                {/* Label κόμβου */}
                                <motion.text
                                    x={node.x + 30}
                                    y={node.y + 35}
                                    textAnchor="middle"
                                    className="text-lg font-bold fill-white pointer-events-none"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ duration: 0.5, delay: 0.5 + index * 0.1 }}
                                >
                                    {node.id}
                                </motion.text>
                            </motion.g>
                        ))}
                    </svg>
                </div>

                <motion.div>
                    <div style={{ display: "flex", justifyContent: "space-between", gap: "48px" }}>
                        {/* DFS Section (Left) */}
                        <div style={{
                            flex: 1,
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "left",
                            alignItems: "center",
                        }}>
                            <h2 style={{ color: darkMode ? "#e9e9e9ff" : "#080808bb", fontSize: "1.5rem", fontWeight: 600, textAlign: "center", marginRight: "30px" }}>
                                DFS
                            </h2>
                            {renderOptions('DFS', showOptionsDFS, setShowOptionsDFS, dfsResult, selectedDfsOption)}
                        </div>

                        {/* BFS Section (Right) */}
                        <div style={{ flex: 1 }}>
                            <h2 style={{ color: darkMode ? "#e9e9e9ff" : "#080808bb", fontSize: "1.5rem", fontWeight: 600, textAlign: "center", marginRight: "30px" }}>
                                BFS
                            </h2>
                            <div style={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                            }}>
                                {renderOptions('BFS', showOptionsBFS, setShowOptionsBFS, bfsResult, selectedBfsOption)}
                            </div>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default SearchingDirected;